import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";
import { useUrlParams } from "hooks/useUrlParams";

import {
  getGuidelinesUrl,
  termsOfServiceUrls,
  privacyPolicyUrls,
} from "constants/links";

const PotionFooter = () => {
  const { soulId, lng, work } = useUrlParams();
  const { t } = useTranslation([work]);
  const navigate = useNavigate();
  const theme = useTheme();

  const withLng = (path) => {
    const hasQuery = path.includes("?");
    return lng ? `${path}${hasQuery ? "&" : "?"}lng=${lng}` : path;
  };

  const links = [
    {
      label: t(`${work}:Footer.guidelines`),
      url: getGuidelinesUrl(work, lng),
    },
    { label: t(`${work}:Footer.terms_of_service`), url: termsOfServiceUrls[lng] },
    { label: t(`${work}:Footer.privacy_policy`), url: privacyPolicyUrls[lng] },
    { label: t(`${work}:Footer.news`), path: `/${work}/news?soul_id=${soulId}` },
    { label: t(`${work}:Footer.contact`), url: "https://line.me/R/ti/p/@314jdaww" },
    { label: t(`${work}:Footer.how_to_play`), path: `/${work}/how-to-use?soul_id=${soulId}` },
    { label: t(`${work}:Footer.my_page`), path: `/${work}/mypage?soul_id=${soulId}` },
    { label: t(`${work}:Footer.quests`), path: `/${work}/quests?soul_id=${soulId}` },
    { label: t(`${work}:Footer.purchase_ticket`), path: `/${work}/tickets?soul_id=${soulId}` },
    { label: t(`${work}:Footer.exchange_money`), path: `/${work}/exchange_money?soul_id=${soulId}` },
    { label: t(`${work}:Footer.payment`), path: `/${work}/payment?soul_id=${soulId}` },
  ];

  const commonStyles = {
    cursor: "pointer",
    transition: "color 0.2s, transform 0.2s",
    "&:hover": { color: "lightgray", transform: "scale(1.05)" },
    "&:active": { color: "gray", transform: "scale(0.95)" },
  };

  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        pt: 5,
        pb: 12,
      }}
    >
      {links.map((link, index) => (
        <Typography
          key={index}
          sx={{
            ...commonStyles,
            ...theme.components.footer,
          }}
          onClick={
            link.path
              ? () => navigate(withLng(link.path))
              : link.url
              ? () => window.open(link.url, "_blank")
              : undefined
          }
        >
          {link.label}
        </Typography>
      ))}
    </Box>
  );
};

export default PotionFooter;
